import React, { useState } from 'react';
import { Space, Select, Button, Typography, Row, Col, Alert, Card, Spin } from 'antd';
import { DownloadOutlined, FileTextOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import { useExportarCsv, useListarTiposDescarga } from './queries';

const { Text, Title } = Typography;

export const DescargaArchivos = () => {
  const [tipo, setTipo] = useState(null);

  const { data: opcionesTipo = [], isLoading: cargandoTipos } = useListarTiposDescarga();
  const exportar = useExportarCsv();

  const handleDownload = async () => {
    if (!tipo) return;
    await exportar.mutateAsync(tipo);
  };

  const handleTipoChange = (value) => {
    setTipo(value ?? null);
  };

  const tipoSeleccionado = opcionesTipo.find(opt => opt.value === tipo);

  return (
    <div style={{ maxWidth: 680, margin: '0 auto' }}>
      {/* Encabezado */}
      <div style={{ textAlign: 'center', marginBottom: 28 }}>
        <CloudDownloadOutlined style={{ fontSize: 28, color: '#1890ff', marginBottom: 6, display: 'block' }} />
        <Title level={4} style={{ margin: 0 }}>Descarga de archivos</Title>
        <Text type="secondary" style={{ fontSize: 13 }}>
          Exporta datos del sistema en formato CSV
        </Text>
      </div>

      <Space direction="vertical" style={{ width: '100%' }} size={20}>

        {/* Selector de tipo */}
        <Card
          size="small"
          style={{ borderRadius: 12, border: '1.5px solid #d9d9d9' }}
          bodyStyle={{ padding: '20px' }}
        >
          <Row align="middle" gutter={12} style={{ marginBottom: 12 }}>
            <Col>
              <FileTextOutlined style={{ fontSize: 20, color: '#1890ff' }} />
            </Col>
            <Col flex="auto">
              <Text strong>¿Qué datos quieres exportar?</Text>
            </Col>
          </Row>
          <Spin spinning={cargandoTipos}>
            <Select
              style={{ width: '100%' }}
              size="large"
              placeholder="Selecciona el tipo de datos..."
              value={tipo}
              onChange={handleTipoChange}
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={opcionesTipo.map(op => ({ value: op.value, label: op.label }))}
            />
          </Spin>
          {tipoSeleccionado && (
            <Text type="secondary" style={{ fontSize: 12, marginTop: 8, display: 'block' }}>
              {tipoSeleccionado.description}
            </Text>
          )}
        </Card>

        {/* Acción de descarga */}
        <Card
          size="small"
          style={{
            borderRadius: 12,
            border: tipo ? '1.5px solid #d9d9d9' : '1.5px dashed #e8e8e8',
            opacity: tipo ? 1 : 0.55,
          }}
          bodyStyle={{ padding: '20px' }}
        >
          <Row align="middle" justify="space-between" gutter={[16, 12]}>
            <Col flex="auto">
              <Row align="middle" gutter={12}>
                <Col>
                  <DownloadOutlined style={{ fontSize: 20, color: '#52c41a' }} />
                </Col>
                <Col>
                  <Text strong style={{ display: 'block' }}>Descargar CSV</Text>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    Refleja el estado actual de la base de datos
                  </Text>
                </Col>
              </Row>
              {!tipo && (
                <Alert
                  message="Selecciona primero el tipo de archivo"
                  type="warning"
                  showIcon
                  style={{ marginTop: 12, borderRadius: 8 }}
                />
              )}
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleDownload}
                disabled={!tipo}
                loading={exportar.isLoading}
                size="large"
                style={{
                  borderRadius: 25,
                  paddingLeft: 24,
                  paddingRight: 24,
                  height: 44,
                }}
              >
                Descargar
              </Button>
            </Col>
          </Row>
        </Card>

      </Space>
    </div>
  );
};

export default DescargaArchivos;
